import bsTab from 'bootstrap/js/dist/tab';

export default {
  install: (app, options) => {
    let tabs;
    const tabTriggers = [];

    const getParam = (param) => {
      var result = null,
        tmp = [];

      location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === param) result = decodeURIComponent(tmp[1]);
        });

      if (result === 'undefined') {
        return null
      } else {
        return result
      }
    }

    const setParam = (key, value) => {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);

      params.set(key, value);

      url.search = params.toString();
      window.history.replaceState({}, '', url);
    }

    // const removeParam = (key) => {
    //   const sourceURL = location.protocol + '//' + location.host + location.pathname
    //   var urlparts = window.location.search.split('?')

    //   if (urlparts.length >= 2) {
    //     var prefix = encodeURIComponent(key) + '='
    //     var pars = urlparts[1].split(/[&;]/g)

    //     //reverse iteration as may be destructive
    //     for (var i = pars.length; i-- > 0;) {
    //       //idiom for string.startsWith
    //       if (pars[i].lastIndexOf(prefix, 0) !== -1) {
    //         pars.splice(i, 1)
    //       }
    //     }

    //     window.history.replaceState(null, null, sourceURL + urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : ''))
    //   }
    // }

    const init = () => {
      tabs = document.querySelectorAll('[role="tablist"] button');
      tabs.forEach(button => {
        tabTriggers.push(new bsTab(button));
      });

      const initActiveTab = getParam('tab');

      if (initActiveTab) {
        show(initActiveTab)
      }
    };

    const show = id => {
      tabTriggers.forEach((tabTrigger, index) => {
        if (tabTrigger._config.target === `#${id}`) {
          tabTrigger.show();
          setParam('tab', id)

          // Add - Remove class on parent element
          const parentEl = document.querySelector('[role="tablist"]');
          // const parentEl = tabTrigger._parent;
          const classesToRemove = Array.from(parentEl.classList).filter(className => className.startsWith('active-'));
          classesToRemove.forEach(className => parentEl.classList.remove(className));
          parentEl.classList.add(`active-${index}`)
        }
      });
    }

    const tabsPlugin = { show, init };
    app.config.globalProperties.$tabs = tabsPlugin;
    app.provide('$tabs', tabsPlugin);
  }
}